import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AiQuota } from './types';

const initialState: AiQuota | null = null;

const aiQuotaSlice = createSlice({
  name: 'aiQuota',
  initialState: initialState as AiQuota | null,
  reducers: {
    quotaReceived: (_state, action: PayloadAction<AiQuota>) => action.payload,
  },
});

export const { quotaReceived } = aiQuotaSlice.actions;

export const selectAiQuota = (state: { aiQuota: AiQuota | null }) =>
  state.aiQuota;

export const aiQuotaReducer = aiQuotaSlice.reducer;
